var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.792 4.66 3.259 7.017A.167.167 0 0 1 3 6.877v-4.71a.167.167 0 0 1 .26-.139l3.532 2.355a.167.167 0 0 1 0 .278"
})));
export { SvgPlayIcon as ReactComponent };
export default __webpack_public_path__ + "10b1458f73eb81d2fab72bfe4efc88bc.svg";